import { render } from "./RegistrationSuccess.vue?vue&type=template&id=b9247558"
import script from "./RegistrationSuccess.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccess.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\poll_dashboard_new\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__